"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayName = void 0;
const react_1 = __importDefault(require("react"));
const DisplayName = ({ displayName }) => {
    if (!displayName)
        return null;
    return react_1.default.createElement("span", { className: "display-name user-label" }, displayName);
};
exports.DisplayName = DisplayName;
//# sourceMappingURL=DisplayName.js.map